import { useState, useEffect, useCallback } from 'react';
import type { Inspection } from '../types';
import { inspectionRepository } from '../data/inspectionRepository';

/**
 * useInspectionDetail フックの戻り値
 */
interface UseInspectionDetailReturn {
  data: Inspection | null;
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

/**
 * 点検詳細を取得するフック
 */
export const useInspectionDetail = (
  id: number
): UseInspectionDetailReturn => {
  const [data, setData] = useState<Inspection | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await inspectionRepository.getById(id.toString());
      if (result.success) {
        if (!result.data) {
          throw new Error('点検データが見つかりません');
        }
        setData(result.data);
      } else {
        throw new Error(result.error.message);
      }
    } catch (e) {
      setError(e as Error);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading, error, refetch: fetchData };
};
